import { defineMessages } from "react-intl";

const MERGE_ERROR = "merge-error";

const mergeErrorMessages = defineMessages({
  accountsCannotBeMerged: {
    id: `${MERGE_ERROR}.accounts-cannot-be-merged`,
    defaultMessage: "Accounts cannot be merged at this time"
  },
  youMustResolveIssues: {
    id: `${MERGE_ERROR}.you-must-resolve-issues`,
    defaultMessage:
      "You must resolve these issues to merge your user account data."
  },
  problemMergingAccounts: {
    id: `${MERGE_ERROR}.problem-merging-accounts`,
    defaultMessage: "We're sorry, there was a problem merging your accounts."
  }
});

export default mergeErrorMessages;
